import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  // POS Search
  searchQuery: '',
  selectedProduct: null,

  // FULL PRODUCT FORM DATA (1:1 with API)
  formData: {
    id: null,
    name: '',
    sku: '',
    barcode: null,
    custom_barcode: null,
    description: '',
    unit: 'pcs',
    price_inclusive_tax: false,
    active: true,
    // Price Tiers
    standard_rate: '0.0',
    wholesale_price: '0.0',
    retail_price: '0.0',
    mrp: '0.0',
    // Nested Objects
    category: {
      id: '',
      name: ''
    },
    hsn_code: {
      id: '',
      code: ''
    },
    article: null,
    attributes: [],
    organization_id: null,
    product_metadata_attributes: [] // For custom key/value pairs
  },
};

const productSlice = createSlice({
  name: 'product',
  initialState,
  reducers: {
    setProductSearch: (state, action) => {
      state.searchQuery = action.payload;
    },

    // Update Top Level Fields (name, sku, retail_price, etc.)
    updateFormField: (state, action) => {
      const { field, value } = action.payload;
      state.formData[field] = value;
    },

    // Update Nested Object Fields (category.id, hsn_code.code)
    updateNestedFormField: (state, action) => {
      const { parent, field, value } = action.payload;
      state.formData[parent][field] = value;
    },

    // Load an existing product into the form for Editing
    setProductForm: (state, action) => {
      state.formData = { ...initialState.formData, ...action.payload };
    },

    resetProductForm: (state) => {
      state.formData = initialState.formData;
    },

    // Metadata Handlers
    addMetadataAttribute: (state) => {
      state.formData.product_metadata_attributes.push({ key: '', value: '', description: '' });
    },
    updateMetadataAttribute: (state, action) => {
      const { index, field, value } = action.payload;
      state.formData.product_metadata_attributes[index][field] = value;
    }
  }
});

export const {
  setProductSearch,
  updateFormField,
  updateNestedFormField,
  setProductForm,
  resetProductForm,
  addMetadataAttribute,
  updateMetadataAttribute
} = productSlice.actions;

export default productSlice.reducer;
